export const PASSWORD_POLICY_MESSAGE =
  "Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character.";

export function isStrongPassword(value) {
  const password = String(value || "");
  return (
    password.length >= 8 &&
    /[A-Z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  );
}
